import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { User } from './../../_models/user';
import { JwtHelperService } from '@auth0/angular-jwt';
import { map, mergeMap } from 'rxjs/operators';
import { FilterService } from './../filter.service';
import { DynamicTableService } from './../dynamic-table.service';
import { DocumentsService } from './../documents.service';
import { UserService } from './../user.service';
import { AppService } from './../app.service';
import { TextFiltersService } from './../text-filters.service';
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { environment } from './../../../environments/environment';
import { teamConfig } from './../sso.config';
import * as sjcl from 'sjcl';
import moment from 'moment';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
const helper = new JwtHelperService();
import { ErrorDiagnosticService } from './../error-diagnostic.service';
import { AppInsightService } from './../app-insight.service';

@Injectable({
  providedIn: 'root'
})
export class MockAuthService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser$: Observable<User>;
  
  constructor(
    private msalService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    public jwtHelper: JwtHelperService,
    public appInsightService : AppInsightService,
    private http: HttpClient,
    private dynamicTableService: DynamicTableService,
    private documentsService: DocumentsService,
    private userService: UserService,
    private filterService: FilterService,
    private router: Router,
    private appService: AppService,
    private oauthService: OAuthService,
    private textFiltersService: TextFiltersService,
    private diagnosticService: ErrorDiagnosticService) {
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('user')));
    
    if(this.currentUserSubject.value){
      this.diagnosticService.setUser(this.currentUserSubject.value.name);
    }
    
    this.currentUser$ = this.currentUserSubject.asObservable();
  }

  public isAuthenticated(): boolean {
    return true;
 }

  public get currentUserValue(): User {
    return this.currentUserSubject.value; 
  }

  getCurrentLocation() {

  }

  changeCurrentLocation(id) {

  }

  getProfile(locationId, roleId) {

  }

  loadMocks(configData) {
    this.filterService.loadMockFilters();
    this.filterService.loadMockConfigFilters();
  }

  getCurrentUser() {
  }

  getConfigData(locationid, roleid) {

  }

  teamAuth(params) {

  }

  getUserInfo(token) {
  }

  adAuth(data) {
  }

  checkRol(rol) {

  }

  async generateCodeChallenge(codeVerifier) {

  }

  getLocations(userData = {}) {

  }

  storeUser(type, user = null) {

  }

  logoutProv(prov: string = null) {

  }

  logout() {
  }

  clearStores(key: string = null) {

  }

  loginRedirectAd() {

  }

  checkUserSession() {

  }

  setUserStorage(session) {

  }

  hasSigners() {
    return false;
  }
}